"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchFileById = exports.getIndicatedIds = exports.getFirstOpenFile = exports.getDefaultExpandedFolders = void 0;
/* eslint-disable */
var getDefaultExpandedFoldersbyIsIndicated = function (tree, list, res) {
    if (res.length >= 1) {
        return res;
    }
    if (tree.type === 'file') {
        if (tree.isIndicated) {
            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                var item = list_1[_i];
                if (!res.includes(item)) {
                    res.push(item);
                }
            }
            return res;
        }
    }
    if (tree.type === 'directory' && tree.children) {
        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
            var child = _b[_a];
            getDefaultExpandedFoldersbyIsIndicated(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
        }
    }
    return res;
};
var getDefaultExpandedFoldersByFirstFile = function (tree, list, res) {
    if (res.length >= 1) {
        return res;
    }
    if (tree.type === 'file') {
        for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
            var item = list_2[_i];
            if (!res.includes(item)) {
                res.push(item);
            }
        }
        return res;
    }
    if (tree.type === 'directory' && tree.children) {
        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
            var child = _b[_a];
            getDefaultExpandedFoldersByFirstFile(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
        }
    }
    return res;
};
var getDefaultExpandedFolders = function (tree) {
    var folders = getDefaultExpandedFoldersbyIsIndicated(tree, [], []);
    return folders.length !== 0 ? folders : getDefaultExpandedFoldersByFirstFile(tree, [], []);
};
exports.getDefaultExpandedFolders = getDefaultExpandedFolders;
var getFirstOpenFile = function (tree) {
    return getFirstIndicatedFileIdInTree(tree) || getFirstFileIdInTree(tree);
};
exports.getFirstOpenFile = getFirstOpenFile;
var getFirstFileIdInTree = function (tree) {
    if (tree.type === 'file') {
        return tree.id;
    }
    if (tree.type === 'directory' && tree.children)
        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var res = getFirstFileIdInTree(child);
            if (res) {
                return res;
            }
        }
    return '';
};
var getFirstIndicatedFileIdInTree = function (tree) {
    if (tree.type === 'file' && tree.isIndicated) {
        return tree.id;
    }
    if (tree.type === 'directory' && tree.children)
        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var res = getFirstIndicatedFileIdInTree(child);
            if (res) {
                return res;
            }
        }
    return '';
};
var getIndicatedIds = function (tree, list, res) {
    if (tree.type === 'file') {
        if (tree.isIndicated) {
            res.push(tree.id);
            for (var _i = 0, list_3 = list; _i < list_3.length; _i++) {
                var item = list_3[_i];
                if (!res.includes(item)) {
                    res.push(item);
                }
            }
        }
        return res;
    }
    if (tree.children)
        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
            var child = _b[_a];
            (0, exports.getIndicatedIds)(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
        }
    return res;
};
exports.getIndicatedIds = getIndicatedIds;
var searchFileById = function (tree, id) {
    if (tree.type === 'file' && tree.id === id) {
        return tree;
    }
    if (tree.type === 'directory' && tree.children) {
        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var res = (0, exports.searchFileById)(child, id);
            if (res) {
                return res;
            }
        }
    }
    return null;
};
exports.searchFileById = searchFileById;
